module.exports = __webpack_public_path__ + "static/img/brees-2016-slide-5.b939858.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2016-slide-5.jpg
// module id = QVLr
// module chunks = 1